import { fcDelete } from '@seeqdev/icons/seeq';
import Icon from '../Icon';
import type { AlertProps } from './Alert.types';

const baseClasses =
  'tw:mx-auto tw:leading-normal tw:outline-none tw:py-2 tw:px-3 tw:rounded-[10px] tw:w-full tw:relative' +
  ' tw:border-solid tw:border tw:text-sm tw:flex tw:flex-col tw:justify-center tw:items-center';

const darkTheme = 'tw:dark:bg-sq-theme-hover-dark tw:dark:text-sq-text-color-dark';
const lightTheme = 'tw:text-sq-text-color tw:bg-sq-theme-highlight/10';

const errorClasses = 'tw:border-sq-danger';

const borderColorClasses = 'tw:border-sq-theme-dark';

/**
 * Alert.
 */
export const Alert = ({
  children,
  dismissible = true,
  onClose,
  show = true,
  variant,
  testId = 'alert-id',
  id,
  extraClassNames,
  ...tooltipProps
}: AlertProps) => {
  const appliedTheme: Record<AlertProps['variant'], string> = {
    theme: `${lightTheme} ${darkTheme}`,
    formulaError: 'tw:text-red-800 tw:bg-red-200 tw:rounded-[0.25rem]!',
    danger: 'tw:text-sq-text-color tw:bg-sq-danger',
    warning: 'tw:bg-sq-bg-warning tw:text-sq-text-color tw:dark:text-sq-multi-gray-dark',
    gray: 'tw:bg-sq-hover-gray tw:text-sq-text-color tw:dark:bg-sq-tools-background-dark tw:dark:text-sq-text-color-dark',
  };
  const appliedBorderTheme: Record<AlertProps['variant'], string> = {
    theme: borderColorClasses,
    danger: errorClasses,
    warning: 'tw:border-0',
    gray: 'tw:border-sq-darkish-gray',
    formulaError: 'tw:border-red-100',
  };
  const appliedClasses = `${baseClasses} ${appliedTheme[variant]} ${extraClassNames} ${appliedBorderTheme[variant]}`;

  if (!show) {
    return <div />;
  }
  return (
    <div data-testid={testId} id={id} className={appliedClasses}>
      {children}
      {dismissible && (
        <Icon
          icon={fcDelete}
          type={variant.match(/danger|warning|formulaError/) ? 'color' : 'theme'}
          color={variant.match(/danger|warning|formulaError/) ? 'inherit' : undefined}
          extraClassNames={`tw:self-end tw:text-size-11 tw:cursor-pointer tw:absolute tw:right-2.5 tw:top-2.5 ${
            variant.match(/danger|warning|gray|formulaError/) ? 'tw:text-sq-text-color tw:dark:text-sq-dark-text' : ''
          }`}
          testId={`${testId}-close-btn`}
          onClick={onClose}
          {...tooltipProps}
        />
      )}
    </div>
  );
};
